import React from 'react';
import Button from '@mui/material/Button';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';
import T from 'i18n';
import styles from '../CaseIntelligencePage.module.scss';

interface Props {
  onGenerate: () => void;
  pending: boolean;
  hint?: string | null;
}

const EmptyState: React.FC<Props> = ({ onGenerate, pending, hint }) => {
  return (
    <div className={styles.emptyState}>
      <InsightsOutlinedIcon className={styles.emptyIcon} style={{ fontSize: 48 }} />
      <h2 className={styles.emptyTitle}>{T.translate('caseIntelligence.emptyTitle')}</h2>
      <p className={styles.emptyDescription}>
        {hint || T.translate('caseIntelligence.emptyDescription')}
      </p>
      <Button variant="contained" color="primary" onClick={onGenerate} disabled={pending}>
        {T.translate('caseIntelligence.generateArtefacts')}
      </Button>
    </div>
  );
};

export default EmptyState;
